const de = {
  // Header / Navigation
  'nav.sports': 'Sportwetten',
  'nav.live': 'Livewetten',
  'nav.games': 'Games',
  'nav.promotions': 'Aktionen',
  'nav.deposit': 'Einzahlung',
  'nav.myBets': 'Meine Wetten',
  'nav.news': 'Neuigkeiten',
  'nav.account': 'Konto',
  'nav.login': 'Anmelden',
  'nav.register': 'Registrieren',
  'nav.logout': 'Abmelden',

  // Login
  'login.welcome': 'Willkommen',
  'login.noAccount': 'Sie haben noch kein Konto?',
  'login.registerNow': 'Jetzt registrieren',
  'login.requiredFields': '* markierte Felder sind Pflichtfelder.',
  'login.emailUsername': '* E-Mail / Benutzername',
  'login.password': '* Passwort',
  'login.hidePassword': 'Passwort verbergen',
  'login.showPassword': 'Passwort anzeigen',
  'login.rememberMe': 'Angemeldet bleiben',
  'login.loginButton': 'Anmelden',
  'login.pleaseWait': 'Bitte warten...',
  'login.forgotPassword': 'Passwort vergessen?',
  'login.shopCustomer': 'Sind Sie Shop-Kunde?',
  'login.activateOnlineAccount': 'Online-Konto aktivieren',
  'login.failed': 'Anmeldung fehlgeschlagen',
  'login.invalidCredentials': 'Ungültige Anmeldedaten',

  // Sidebar
  'sidebar.search': 'Team, Event oder Wettbewerb',
  'sidebar.quickAccess': 'Schnellzugriff',
  'sidebar.topEvents': 'Top-Events',
  'sidebar.topKombis': 'Top-Kombis',
  'sidebar.todayMatches': 'Spiele von heute',
  'sidebar.germanFootball': 'Deutscher Fußball',
  'sidebar.europeanFootball': 'Europäischer Fußball',
  'sidebar.topCompetitions': 'Top-Wettbewerbe',
  'sidebar.topSports': 'Top-Sportarten',
  'sidebar.allSports': 'Alle Sportarten',
  'sidebar.showAllCategories': 'Alle Kategorien anzeigen',
  'sidebar.hideCategories': 'Kategorien ausblenden',

  // Sports
  'sport.football': 'Fußball',
  'sport.tennis': 'Tennis',
  'sport.basketball': 'Basketball',
  'sport.iceHockey': 'Eishockey',
  'sport.handball': 'Handball',
  'sport.baseball': 'Baseball',
  'sport.americanFootball': 'American Football',
  'sport.boxing': 'Boxen',
  'sport.cricket': 'Cricket',
  'sport.darts': 'Darts',
  'sport.rugby': 'Rugby',
  'sport.tableTennis': 'Tischtennis',
  'sport.beachVolleyball': 'Beach-Volleyball',
  'sport.volleyball': 'Volleyball',
  'sport.esports': 'E-Sports',

  // Market Types
  'market.tip': 'Tipp',
  'market.tipRemainingTime': 'Tipp Restzeit',
  'market.firstHalf': '1. Halbzeit',
  'market.overUnder': 'Über/Unter',
  'market.doubleChance': 'Doppelte Chance',
  'market.bothTeamsScore': 'Beide Teams treffen',

  // Bet Outcomes
  'outcome.fhHomeWinRemainingTime': '1.Hz Heimsieg Restzeit',
  'outcome.fhDrawRemainingTime': '1.Hz Unent. Restzeit',
  'outcome.fhAwayWinRemainingTime': '1.Hz Auswärts Restzeit',
  'outcome.fhNextGoalHome': '1.Hz Nächstes Tor Heim',
  'outcome.fhNextGoalAway': '1.Hz Nächstes Tor Auswärts',
  'outcome.nextGoalHome': 'Nächstes Tor Heim',
  'outcome.nextGoalAway': 'Nächstes Tor Auswärts',
  'market.nextGoal': 'Nächstes Tor',
  'outcome.home': 'Heim',
  'outcome.away': 'Gast',
  'outcome.homeWin': 'Heimsieg',
  'outcome.draw': 'Unentschieden',
  'outcome.awayWin': 'Auswärtssieg',
  'outcome.over': 'Über',
  'outcome.under': 'Unter',
  'outcome.yes': 'Ja',
  'outcome.no': 'Nein',
  'outcome.fhHomeWin': '1.Hz Heimsieg',
  'outcome.fhDraw': '1.Hz Unentschieden',
  'outcome.fhAwayWin': '1.Hz Auswärtssieg',
  'outcome.fhOver': '1.Hz Über',
  'outcome.fhUnder': '1.Hz Unter',
  'outcome.homeWinRemainingTime': 'Heimsieg Restzeit',
  'outcome.drawRemainingTime': 'Unent. Restzeit',
  'outcome.awayWinRemainingTime': 'Auswärtssieg Restzeit',

  // Section Titles
  'section.nextGames': 'Nächste Spiele',
  'section.topEvents': 'Top-Events',
  'section.lastMinute': 'Last Minute',
  'section.live': 'Live',
  'section.next6Hours': 'Nächste 6 Stunden',
  'section.topKombis': 'Top-Kombis',
  'section.topKombisSubtitle': 'von anderen Tipico Kunden',
  'section.showAll': 'Alle anzeigen',
  'section.viewAll': 'Alle',

  // Betting Slip
  'slip.title': 'Wettschein',
  'slip.empty': 'Dein Wettschein ist noch leer.',
  'slip.emptyHint': 'Wähle jetzt deine Wetten aus.',
  'slip.single': 'Einzel',
  'slip.combi': 'Kombi',
  'slip.system': 'System',
  'slip.stake': 'Einsatz',
  'slip.totalStake': 'Gesamteinsatz',
  'slip.setStake': 'Einsatz setzen',
  'slip.totalOdds': 'Gesamtquote',
  'slip.potentialWin': 'Möglicher Gewinn',
  'slip.placeBet': 'Wette platzieren',
  'slip.openBets': 'Offene Wetten',
  'slip.viewTicket': 'Wettschein ansehen',
  'slip.noOpenBets': 'Du hast keine offenen Wetten.',
  'slip.combiBet': 'Kombiwette',
  'slip.singleBet': 'Einzelwette',
  'slip.singleBets': 'Einzelwetten',
  'slip.potentialWinShort': 'Mögl. Gewinn',
  'slip.maxWin': 'Max. Gewinn',
  'slip.requestCashout': 'Cashout Anfragen',
  'slip.combinations': 'Kombinationen (Wege)',
  'slip.cashoutValue': 'Cashout Wert',
  'slip.confirmCashout': 'Cashout bestätigen',
  'slip.errorRequestingQuote': 'Fehler beim Anfordern des Quotes.',
  'slip.cashoutFailed': 'Cashout fehlgeschlagen.',
  'slip.error.payoutLimitExceeded': 'Maximales Auszahlungslimit überschritten. Bitte verringern Sie Ihren Einsatz.',
  'slip.errorPlacingBet': 'Fehler beim Platzieren der Wette.',
  'slip.placementScore': 'Wette Platziert bei:',
  'slip.currentScore': 'Aktuell:',
  'slip.placingBet': 'Wettschein wird erstellt...',
  'slip.placingWait': 'Bitte warten, in Bearbeitung...',
  'slip.placingBtn': 'Wird platziert...',
  'slip.betSuccess': 'Wettschein bestätigt',
  'slip.betSuccessDesc': 'Ihre Wette wurde erfolgreich platziert!',
  'slip.hasLockedBets': 'Ihr Schein enthält gesperrte/ausgesetzte Wetten.',

  // Live
  'live.noEvents': 'Keine Live-Ereignisse für',
  'live.games': 'Spiele',
  'live.sortBy': 'Sortiere nach:',
  'live.time': 'Zeit',
  'live.competition': 'Wettbewerb',
  'live.halfTime': '1. Halbzeit',
  'live.ht': 'HZ',
  'live.ft': 'FT',

  // Time
  'time.today': 'Heute',
  'time.tomorrow': 'Morgen',
  'time.minutes': 'Min',
  'time.hoursShort': 'Std.',

  // Top Kombis Card
  'kombis.betsPlaced': 'Wetten platziert',
  'kombis.combi': 'Kombi',
  'kombis.totalOdds': 'Gesamtquote',
  'kombis.tip': 'Tipp',

  // Account
  'account.myAccount': 'Mein Konto',
  'account.loginPrompt': 'Bitte melde dich an, um dein Konto zu verwalten.',
  'account.verification': 'Kontoverifizierung',
  'account.management': 'Kontoverwaltung & Limits',
  'account.transactions': 'Transaktionen',
  'account.personalData': 'Persönliche Daten',
  'account.responsibleGaming': 'Verantwortungsvolles Spielen',
  'account.meineDaten': 'Meine Daten',
  'account.kontoverifizierung': 'Kontoverifizierung',
  'account.kontoverwaltung': 'Kontoverwaltung & Limits',
  'account.transaktionsverlauf': 'Transaktionsverlauf',
  'account.guthaben': 'Guthaben',
  'account.auszahlung': 'Auszahlung',
  'account.einstellungen': 'Einstellungen',
  'account.neuigkeiten': 'Neuigkeiten',
  'account.apps': 'Tipico Apps',
  'account.kontakt': 'Kontakt',
  'account.abmelden': 'Abmelden & Inaktivieren',
  'account.userTabs.personal': 'Benutzerdaten',
  'account.userTabs.contact': 'Kontaktdaten',
  'account.userTabs.password': 'Passwort ändern',
  'account.fields.name': 'Vor- und Nachname:',
  'account.fields.username': 'Benutzername:',
  'account.fields.birthname': 'Geburtsname:',
  'account.fields.birthdate': 'Geburtsdatum:',
  'account.fields.email': 'E-Mail:',
  'account.fields.emailChange': 'E-Mail ändern',
  'account.fields.lugasId': 'Lugas Spieler ID:',
  'account.underConstruction': 'Dieser Bereich befindet sich noch im Aufbau.',
  'account.supportPlaceholder': 'Bitte beschreiben Sie Ihr Anliegen möglichst genau...',
  'account.salutationMr': 'Herr',
  'account.loginBtn': 'Anmelden',
  'account.transactions.title': 'Transaktionsverlauf',
  'account.transactions.type': 'Typ',
  'account.transactions.amount': 'Betrag',
  'account.transactions.status': 'Status',
  'account.transactions.date': 'Datum',
  'account.transactions.id': 'Referenz ID',
  'account.transactions.noTransactions': 'Keine Transaktionen gefunden.',
  'account.transactions.deposit': 'Einzahlung',
  'account.transactions.withdrawal': 'Auszahlung',
  'account.transactions.status.completed': 'Erfolgreich',
  'account.transactions.status.pending': 'Ausstehend',
  'account.transactions.status.failed': 'Fehlgeschlagen',
  'account.transactions.filter.all': 'Alle',
  'account.transactions.filter.startDate': 'Von:',
  'account.transactions.filter.endDate': 'Bis:',
  'account.transactions.filter.reset': 'Zurücksetzen',
  'account.balance.title': 'Guthaben & Geldbörse',
  'account.balance.total': 'Gesamtguthaben',
  'account.balance.available': 'Verfügbar',
  'account.balance.locked': 'Gesperrt',
  'account.balance.realCash': 'Echtgeld',
  'account.balance.bonusCash': 'Bonusguthaben',
  'account.balance.premiumWallet': 'Tipico Premium Geldbörse',
  'account.balance.depositAction': 'Guthaben aufladen',
  'account.balance.withdrawAction': 'Auszahlen',
  'account.balance.recentActivity': 'Letzte Aktivitäten',
  'account.balance.viewAllTransactions': 'Alle Transaktionen anzeigen',
  'account.notifications.title': 'Neuigkeiten & Benachrichtigungen',
  'account.notifications.empty': 'Keine Benachrichtigungen vorhanden.',
  'account.notifications.markAllRead': 'Alle als gelesen markieren',
  'account.notifications.markRead': 'Als gelesen markieren',
  'account.notifications.viewAll': 'Alle anzeigen',
  'account.withdrawal.title': 'Auszahlung veranlassen',
  'account.withdrawal.selectMethod': 'Auszahlungsmethode wählen:',
  'account.withdrawal.amount': 'Auszahlungsbetrag',
  'account.withdrawal.enterAmount': 'Betrag eingeben',
  'account.withdrawal.availableToWithdraw': 'Verfügbares Echtgeld-Guthaben:',
  'account.withdrawal.submit': 'Auszahlung anfordern',
  'account.withdrawal.processingTime': 'Dauer',
  'account.withdrawal.instant': 'Sofort',
  'account.withdrawal.bankDays': '1-3 Werktage',
  'account.withdrawal.successMessage': 'Ihre Auszahlung wurde erfolgreich übermittelt!',
  'account.withdrawal.successSub': 'Der Betrag wird in Kürze Ihrem gewählten Zahlungsmittel gutgeschrieben.',
  'account.withdrawal.refId': 'Referenz-ID:',
  'account.withdrawal.error.insufficient': 'Ungenügendes Echtgeld-Guthaben.',
  'account.withdrawal.error.minimum': 'Der Mindestbetrag für Auszahlungen beträgt 10 €.',
  'account.withdrawal.backToWallet': 'Zurück zum Guthaben',

  // Login/Register
  'auth.loginTitle': 'Anmelden',
  'auth.registerTitle': 'Registrieren',
  'auth.email': 'E-Mail',
  'auth.username': 'Benutzername',
  'auth.password': 'Passwort',
  'auth.confirmPassword': 'Passwort bestätigen',
  'auth.noAccount': 'Noch kein Konto?',
  'auth.hasAccount': 'Hast du bereits ein Konto?',
  'auth.welcomeTitle': 'Tauche in die Welt der Sportwetten ein!',
  'auth.bonusTitle': 'Verdopple deine erste Einzahlung',
  'auth.bonusSubtitle': 'bis 100 €',
  'auth.registrationOnlyGermany': 'Die Registrierung ist nur aus Deutschland möglich.',

  // My Bets
  'bets.myBets': 'Meine Wetten',
  'bets.active': 'Aktiv',
  'bets.settled': 'Abgerechnet',
  'bets.won': 'Gewonnen',
  'bets.lost': 'Verloren',
  'bets.pending': 'Offen',

  // Misc
  'match.mainBets': 'Hauptwetten',
  'match.allBets': 'Alle Wetten',
  'misc.noOdds': 'Oranlar yok',
  'misc.matches': 'Matches',
  'misc.matchKombi': 'MatchKombi+',
  'misc.outrights': 'Outrights',
  'misc.statistics': 'Statistics',
  'misc.search': 'Suchen',
  'misc.close': 'Schließen',
  'misc.back': 'Zurück',
  'misc.events': 'Events',
  'misc.topCompetitions': 'Top-Wettbewerbe',
  'misc.noMatches': 'Keine Begegnungen zum Anzeigen gefunden.',
  'misc.loading': 'Wird geladen…',
  'misc.confirmColon': 'Bestätigen:',
  'misc.confirm': 'Bestätigen',
  'misc.cancel': 'Abbrechen',
  'misc.error': 'Fehler.',
};

export default de;
